import React from 'react';
import { findDOMNode } from 'react-dom';
import autobind from 'autobind-decorator';
import StringStore from 'client/stores/strings';
import Base from 'client/components/base';
import ChannelGrid from 'client/components/common/channel-grid';
import ChannelList from 'client/components/common/channel-list';
import Button from 'client/components/common/button-rounded';
import Loader from 'client/components/common/loader';
import baseUrl from 'server/routes/base-url';

const BREAKPOINT = 750; // when to switch to mobile

export default class GridLandingModule extends Base {
  static get propTypes() {
    return {
      module: React.PropTypes.object.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      screenWidth: 300,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  @autobind
  onResize() {
    let element = findDOMNode(this.refs.container);
    if (element) {
      this.setState({
        screenWidth: element.getBoundingClientRect().width,
      });
    }
  }

  render() {
    if (this.props.module.children.length) {
      let tagClasses = this.css({
        base: 'section-tag',
        compose: ['text-color2'],
      });

      let titleClass = this.css({
        base: 'section-title',
        compose: ['text-color4'],
      });

      let channels = null;
      if (this.state.screenWidth > BREAKPOINT) {
        channels = (
          <ChannelGrid
            addClassName="channel-grid-raised"
            rows={this.props.module.children.length > 9 ? 2 : 1}
            channels={this.props.module.children}
          />
        );
      } else {
        channels = (
          <ChannelList
            numberOfCols={5}
            numberOfRows={1}
            itemWidth={245}
            itemHeight={220}
            channels={this.props.module.children}
          />
        );
      }

      return (
        <section ref="container" className={this.css()}>
          <div className="channel-container">{channels}</div>
          <div className="content">
            <div className="discover-more-button">
              <Button linkTo={`${baseUrl}discover`}>
                {StringStore.get('home.staffPicks.discover')}
              </Button>
            </div>
          </div>
        </section>
      );
    } else {
      return <div style={{ display: 'none' }}>No Channels Supplied</div>;
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/cc-modules/grid-landing-module/grid-landing-module.es6